import { Component } from '@theme/component';

/**
 * A buy bar that appears once the real one has scrolled away.
 *
 * Borrowed from Prestige, including the part that makes it worth having: the
 * button is not a second form. It carries `form="<id>"`, which associates it
 * with the product form already on the page, so there is one form, one
 * quantity, one variant, and one submit path. A duplicate form would be a
 * second place for the selected variant to be wrong.
 *
 * Visibility is driven by watching the real add-to-cart button rather than by
 * a scroll offset, so it is correct at any viewport and however long the
 * description runs.
 *
 * @extends {Component}
 */
class ProductStickyBarComponent extends Component {
  /** @type {IntersectionObserver | undefined} */
  #observer;

  connectedCallback() {
    super.connectedCallback();

    const target = document.querySelector(this.getAttribute('watch') ?? '');
    if (!target) return;

    this.#observer = new IntersectionObserver(
      ([entry]) => {
        // Shown only once the real button has left the viewport upward, so it
        // never covers the button it duplicates.
        const passed = entry && !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.toggleAttribute('visible', Boolean(passed));
      },
      { threshold: 0 }
    );

    this.#observer.observe(target);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#observer?.disconnect();
  }
}

if (!customElements.get('product-sticky-bar-component')) {
  customElements.define('product-sticky-bar-component', ProductStickyBarComponent);
}
